import { render, staticRenderFns } from "./StockStats.vue?vue&type=template&id=7316273a&scoped=true"
import script from "./StockStats.vue?vue&type=script&lang=js"
export * from "./StockStats.vue?vue&type=script&lang=js"
import style0 from "./StockStats.vue?vue&type=style&index=0&id=7316273a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7316273a",
  null
  
)

export default component.exports